// Small, checked ways to reach into the page. A missing part of the page is
// a bug in our own markup, so it throws; everything else is a value.

import { renderHtml, type Html } from "../boundary/html.ts"

export const part = (root: ParentNode, selector: string): HTMLElement => {
  const el = root.querySelector(selector)
  if (!(el instanceof HTMLElement)) throw new Error(`the page has no ${selector}`)
  return el
}

export const parts = (root: ParentNode, selector: string): readonly HTMLElement[] =>
  Array.from(root.querySelectorAll(selector)).filter((el) => el instanceof HTMLElement)

export const maybePart = (root: ParentNode, selector: string): HTMLElement | undefined => {
  const el = root.querySelector(selector)
  return el instanceof HTMLElement ? el : undefined
}

// The element under an event that matches a selector, if any.
export const closest = (e: Event, selector: string): HTMLElement | undefined => {
  const t = e.target
  if (!(t instanceof Element)) return undefined
  const el = t.closest(selector)
  return el instanceof HTMLElement ? el : undefined
}

// `hidden` may be true, false or "until-found"; only false shows the element.
export const isHidden = (el: HTMLElement): boolean => el.hidden !== false

export const setHtml = (el: Element, h: Html): void => {
  el.innerHTML = renderHtml(h)
}

export const numberData = (el: HTMLElement, name: string): number | undefined => {
  const v = el.dataset[name]
  if (v === undefined || v === "") return undefined
  const n = Number(v)
  return Number.isFinite(n) ? n : undefined
}

// Restart a CSS animation class: remove it, force a reflow, add it again.
export const replay = (el: Element, cls: string): void => {
  el.classList.remove(cls)
  void el.getBoundingClientRect()
  el.classList.add(cls)
}
